// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CGt4W","sub-container":"styles_sub-container__ZwVOP"};